// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.verifier[data-v-660f48c5] {\n  color: #00A551;\n  cursor: pointer;\n  padding: 0;\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
